export default __webpack_public_path__ + "static/media/arturo-fuente2.c0aa1fef.png";